import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Flowerlist from '../views/Flowerlist.vue'
import Bouquet from '../views/Bouquet.vue'
// import Newinfo from '../views/Newinfo.vue'
import Flowers from '../views/Flowers.vue'
import User from '../views/User.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/flowerlist',
    name: 'Flowerlist',
    component: Flowerlist
  },
  {
    path: '/bouquet',
    name: 'Bouquet',
    component: Bouquet
  },
  {
    path: '/user',
    name: 'User',
    component: User
  },
  // {
  //   path: '/newinfo',
  //   name: 'Newinfo',
  //   component: Newinfo
  // },
  {
    path: '/flowers',
    name: 'Flowers',
    component: Flowers
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  routes
})

export default router
